export default {
  title: "База знаний",
  description: "Управление и поиск элементов знаний",

  // Search
  searchPlaceholder: "Поиск по содержанию и заголовкам...",
  searchResults: "Результаты поиска",
  noResults: "Результаты не найдены",
  resultsCount: "{count} результатов",

  // Filters
  filters: "Фильтры",
  filterByType: "Фильтр по типу",
  filterByStatus: "Фильтр по статусу",
  filterByDepartment: "Фильтр по отделу",
  filterByStream: "Фильтр по потоку",
  filterByOwner: "Фильтр по владельцу",
  allTypes: "Все типы",
  allStatuses: "Все статусы",
  allDepartments: "Все отделы",
  allStreams: "Все потоки",
  allOwners: "Все владельцы",
  resetFilters: "Сбросить фильтры",

  // Sorting
  sortBy: "Сортировать по",
  sortNewest: "Новейшие",
  sortOldest: "Старейшие",
  sortPriority: "Приоритет",
  sortConfidence: "Достоверность",
  sortTitle: "Название",

  // Card display
  showMore: "Показать больше",
  showLess: "Показать меньше",
  createdAt: "Создано",
  updatedAt: "Обновлено",
  author: "Автор",
  confidence: "Достоверность",
  priority: "Приоритет",
  type: "Тип",
  departments: "Отделы",
  streams: "Потоки",
  tags: "Теги",

  // Status badges
  draft: "Черновик",
  classified: "Классифицированный",
  reviewed: "Проверенный",
  approved: "Утвержденный",
  locked_to_sot: "Заблокированный SOT",
  deprecated: "Устаревший",
  archived: "В архиве",
  rejected: "Отклоненный",

  // Confidence badges
  low: "Низкая",
  medium: "Средняя",
  high: "Высокая",
  verified: "Проверенная",

  // Priority badges
  critical: "Критический",
  priorityHigh: "Высокий",
  normal: "Обычный",

  // Owner domains
  case_preparation: "Подготовка дел",
  sales: "Продажи",
  recruitment: "Рекрутинг",
  finance: "Финансы",
  systems: "Системы",
  management: "Управление",

  // Actions
  addNew: "Добавить новый элемент",
  edit: "Редактировать",
  delete: "Удалить",
  export: "Экспорт",
  refresh: "Обновить",
  viewDetails: "Посмотреть детали",

  // Detail view
  fullContent: "Полное содержание",
  metadata: "Метаданные",
  lifecycle: "Жизненный цикл",
  sourceInfo: "Информация об источнике",
  relations: "Связи",
  linkedItems: "Связанные элементы",
  useCases: "Случаи использования",
  lenses: "Линзы",
  reviewInfo: "Информация о проверке",
  needsResolution: "Требует решения",
  validUntil: "Действительно до",
  reviewDue: "Срок проверки",
  sotLevel: "Уровень SOT",
  visibility: "Видимость",

  // Add new form
  newKnowledgeItem: "Новый элемент знаний",
  titleRequired: "Название обязательно",
  contentRequired: "Содержание обязательно",
  selectType: "Выберите тип",
  selectDepartments: "Выберите отделы",
  selectStreams: "Выберите потоки",
  selectUseCases: "Выберите случаи использования",
  selectLenses: "Выберите линзы",
  selectOwner: "Выберите владельца",
  tagsPlaceholder: "Добавьте теги через запятую...",
  save: "Сохранить",
  cancel: "Отмена",
  saving: "Сохранение...",

  // Visibility options
  internal: "Внутренний",
  ai_internal: "AI Внутренний",
  ai_external: "AI Внешний",
  published: "Опубликованный",

  // Stats
  totalItems: "Всего элементов",
  draftCount: "Черновики",
  approvedCount: "Утвержденные",
  needsReview: "Требуют проверки",
  expiringSoon: "Истекают скоро",

  // Messages
  loadingItems: "Загрузка элементов знаний...",
  errorLoading: "Ошибка загрузки элементов",
  itemSaved: "Элемент успешно сохранен",
  itemDeleted: "Элемент успешно удален",
  errorSaving: "Ошибка сохранения элемента",
  confirmDelete: "Вы уверены, что хотите удалить этот элемент?",

  // ─── Библиотека исследований ───
  research: {
    title: "Библиотека исследований",
    subtitle: "Внешняя информация, только рекомендательная — сама по себе она не становится внутренним законом",
    verdictEmpty: "В библиотеке пока нет источников",
    verdictDue: "{count} источников требуют повторной проверки",
    verdictUndecided: "{count} источников ждут решения",
    verdictClear: "{count} источников — всё актуально и решено",
    lensMissing: "Линза исследований ещё не установлена в базе",
    lensMissingHint: "Выполните миграцию 20260827120000_research_library_seed и обновите страницу",
    empty: "Нет источников, соответствующих фильтрам",
    emptyHint: "Очистите фильтры или добавьте новый источник",
    loading: "Загрузка источников...",
    errorLoading: "Ошибка загрузки источников",
    errorLoadingHint: "Проверьте соединение с базой и обновите страницу",
    searchPlaceholder: "Поиск по заголовкам и содержанию...",
    kpiSources: "Источники",
    kpiUndecided: "Ждут решения",
    kpiDue: "Требуют проверки",
    kpiDomains: "Области",
    openSource: "Открыть источник",
    unsafeUrl: "Адрес заблокирован для показа",
    checkedAt: "Проверено",
    neverChecked: "Не проверялось",
    purpose: "Для чего",
    audience: "Для кого",
    allDomains: "Все области",
    allAuthorities: "Все типы авторитета",
    allStances: "Все решения",
    allFreshness: "Все состояния проверки",
    authority: {
      official: "Официальная документация",
      framework: "Концептуальная рамка",
      learning_map: "Карта обучения",
      community: "Опыт сообщества",
    },
    stance: {
      adopt: "Принимаем",
      reject: "Отклоняем",
      watch: "Наблюдаем",
      have_already: "Уже есть",
      partial: "Частично",
      undecided: "Не решено",
    },
    freshness: {
      fresh: "Актуально",
      due: "Пора проверить",
      overdue: "Просрочено",
      unknown: "Неизвестно",
    },
  },

  // ─── Полка источников ───
  sources: {
    title: "Полка источников",
    subtitle: "Один источник и рядом всё, что из него действительно собрано",
    loading: "Загрузка полки...",
    errorLoading: "Ошибка загрузки полки",
    errorLoadingHint: "Проверьте подключение к базе и обновите страницу",
    searchPlaceholder: "Поиск по названию, автору и заметкам...",
    verdictEmpty: "На полке пока нет источников",
    verdictOrphans: "{count} элементов знаний не связаны ни с одним источником",
    verdictWaiting: "{count} элементов ожидают утверждения",
    verdictEmptyShelves: "{count} источников зарегистрированы, но из них ничего не собрано",
    verdictClear: "{sources} источников и {items} элементов — всё связано и утверждено",
    verdictTruncated: "Выборка обрезана — числа ниже неполные",
    kpiSources: "Источники",
    kpiItems: "Элементы знаний",
    kpiWaiting: "Ожидают утверждения",
    kpiOrphans: "Элементы без источника",
    allKinds: "Все виды источников",
    allTrust: "Все уровни доверия",
    allGates: "Все состояния утверждения",
    noMatch: "Нет источников, соответствующих фильтрам",
    noMatchHint: "Очистите фильтры, чтобы увидеть всю полку",
    truncatedTitle: "Полка больше одной выборки",
    truncatedHint: "Загружено только 1000 элементов. Счётчики фрагментов, сирот и вердикт не отражают полную картину",
    orphanTitle: "Есть элементы без источника",
    orphanHint: "{count} элементов не связаны ни с одной строкой полки, их происхождение неизвестно",
    harvested: "{items} знаний, извлечённых из источника",
    harvestedChunks: "из {chunks} исходных фрагментов текста",
    fillsGap: "Закрывает пробел",
    notes: "Заметки",
    nothingHarvested: "Из этого источника пока ничего не собрано",
    origin: "Исходная строка",
    sotLevel: "Уровень {level}",
    untypedGroup: "Без классификации",
    pickSource: "Выберите источник из списка, чтобы прочитать, что из него извлечено",
    pickSourceHint: "Читалка остаётся на месте, пока вы листаете список",
    closeReader: "Закрыть читалку",
    sourceId: "Идентификатор экземпляра",
    copyId: "Нажмите, чтобы скопировать идентификатор",
    copied: "Скопировано",
    showOrigin: "Показать исходный текст",
    hideOrigin: "Скрыть исходный текст",
    originTitle: "Текст, из которого написан элемент",
    originLoading: "Загрузка исходного текста...",
    originMissing: "Для этого элемента исходный текст не сохранён",
    originError: "Не удалось загрузить исходный текст. Это ошибка, а не отсутствие источника",
    originInvalid: "Ссылка на источник недействительна или не поддерживается и не была загружена",
    addSource: "Добавить источник",
    addSourceTitle: "Новый источник для полки",
    addSourceHint: "Источник регистрируется пустым. Сбор знаний из него — отдельный шаг",
    formTitle: "Название источника",
    formSlug: "Латинский идентификатор",
    formSlugHint: "Только латинские буквы и дефисы, уникальный на полке",
    formAuthor: "Автор",
    formYear: "Год",
    formUrl: "Ссылка",
    formKind: "Вид источника",
    formPriority: "Приоритет",
    formTrust: "Уровень доверия",
    formFillsGap: "Какой пробел закрывает",
    formNotes: "Заметки",
    formSubmit: "Сохранить источник",
    formCancel: "Отмена",
    formSaving: "Сохранение...",
    formRequired: "Название и латинский идентификатор обязательны",
    formDuplicate: "Такой идентификатор уже занят на полке",
    priority: {
      now: "Сейчас",
      soon: "Скоро",
      someday: "Когда-нибудь",
    },
    kind: {
      book: "Книга",
      article: "Статья",
      framework: "Концептуальная рамка",
      internal_wiki: "Внутренняя вики",
      gam_experience: "Опыт GAM",
      ai_conversation: "Беседа с AI",
      external_reference: "Внешний источник",
    },
    trust: {
      authoritative: "Обязательный",
      advisory: "Рекомендательный",
    },
    gate: {
      waiting: "Ожидает утверждения",
      approved: "Утверждён",
      empty: "Пусто",
    },
    status: {
      draft: "Черновик",
      classified: "Классифицирован",
      reviewed: "Проверен",
      approved: "Утверждён",
      locked_to_sot: "Закреплён как источник истины",
      deprecated: "Устарел",
      archived: "В архиве",
      rejected: "Отклонён",
    },
  },
} as const;
